import { Stack, Typography } from "@mui/material";

interface Props {
  label: string;
  children: React.ReactNode;
}

/**
 * Stacks an icon-button trigger on top of a small caption label —
 * used in the desktop top app bar so each action reads as a
 * Google-Ads-style `[icon] / label` tile.
 *
 * Mobile omits the label entirely (the trigger already carries a
 * Tooltip + aria-label), so this helper is only rendered on desktop.
 */
export function LabeledAction({ label, children }: Props) {
  return (
    <Stack alignItems="center" spacing={0} sx={{ lineHeight: 1 }}>
      {children}
      <Typography
        variant="caption"
        sx={{
          mt: -0.25,
          fontSize: "0.6875rem",
          fontWeight: 600,
          color: "text.secondary",
          lineHeight: 1,
          letterSpacing: "0.02em",
          userSelect: "none"
        }}
      >
        {label}
      </Typography>
    </Stack>
  );
}
